import React from 'react';
import { Panel, Copyright } from './styled';

const Footer = () => {
    return (
        <Panel>
            <Copyright>
                Copyright akcode 2021 - react rematch
            </Copyright>
        </Panel>
    );
};

export default Footer;